export default {"src":"/_next/static/media/genussfestival-logo.c086592a.svg","height":288,"width":288};